import PropTypes from "prop-types";

import { H1, H2 } from "../../../../AbstractElements";
import FileHandler from "../../../../CommonElements/FileHandler";

const DatePicker = ({
  questionId,
  questionNumber,
  title,
  handleChange,
  value,
  mediaUrl,
}) => (
  <div className="single-choise">
    <H1 className="single-choise__question">{questionNumber}</H1>
    <H2 className="single-choise__title">{title}</H2>
    {mediaUrl && <FileHandler showPreview={true} mediaUrl={mediaUrl} />}
    <input
      type="date"
      className="form-control mt-2"
      value={value || ""}
      onChange={e => handleChange(questionId, e.target.value)}
    />
  </div>
);
DatePicker.propTypes = {
  questionId: PropTypes.string.isRequired,
  questionNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  title: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  mediaUrl: PropTypes.string,
};

export default DatePicker;
